export interface CreateReferenceListRequest {
  ids: number[]
}

export function CreateReferenceListRequestToJSON(
  value: CreateReferenceListRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
